import {Header} from '~/components';
import {AnnouncementBar} from './AnnouncementBar.client';
import {SITE_NAME} from '~/lib/const';
import {Footer} from './Footer.client';
import {LayoutEntity, SiteSettingsEntity} from '~/types';
import CartDrawerProvider from '~/components/contexts/CartDrawerProvider.client';
import HeaderProvider from '~/components/contexts/HeaderProvider.client';
import {Product} from '@shopify/hydrogen/storefront-api-types';
import {InstantSearch} from 'react-instantsearch';
import algoliaSearchClient from '~/lib/algoliaSync/algolia';
import {useMemo} from 'react';

export function LayoutClient({
  layoutData,
  siteSettingsData,
  children,
  featuredProducts,
}: {
  layoutData?: LayoutEntity[];
  siteSettingsData?: SiteSettingsEntity;
  children: React.ReactNode;
  featuredProducts?: Product[];
}) {
  const logo = {
    "_type": "image",
    "asset": {
        "_ref": "image-18d58416871524db7d156f2c11d0f24ec39b391d-232x67-svg",
        "_type": "reference"
    }
  };
  const {searchInputPlaceholder, announcementBar, header} =
    layoutData?.[0] ?? {};

  const algoliaClient = useMemo(() => algoliaSearchClient, []);

  return (
    /* Make the drawer state available for all component*/
    <InstantSearch indexName="shopify_products" searchClient={algoliaClient}>
      <CartDrawerProvider>
        <HeaderProvider value={header}>
          <div className="flex flex-col min-h-screen">
            <div className="">
              <a href="#mainContent" className="sr-only">
                Skip to content
              </a>
            </div>
            <AnnouncementBar announcementBar={announcementBar} />
            <Header
              data={header}
              title={SITE_NAME}
              logo={logo}
              searchInputPlaceholder={searchInputPlaceholder}
              featuredProducts={featuredProducts}
            />
            <main role="main" id="mainContent" className="flex-grow">
              {children}
            </main>
          </div>

          <Footer data={layoutData?.[0].footer} />
        </HeaderProvider>
      </CartDrawerProvider>
    </InstantSearch>
  );
}
